<template>
  <v-dialog v-model="displayForm" persistent max-width="980px">
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-card>
        <v-card-title>
          {{ model.id ? 'Update Address' : 'Add Address' }}
        </v-card-title>
        <v-card-text :loading="loading" :disabled="loading">
          <v-alert
            :value="message"
            type="error"
            dismissible
            transition="scale-transition"
            >{{ message }}</v-alert
          >
          <v-row>
            <v-col cols="4">
              <v-select
                :items="types"
                label="Type"
                v-model="model.typeId"
                :rules="mandatoryRules"
              ></v-select>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="model.company"
                label="Company"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="model.addressLine1"
                label="Address Line 1"
                :rules="mandatoryRules"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="model.addressLine2"
                label="Address Line 2"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="model.city"
                label="City"
                :rules="mandatoryRules"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="model.state"
                label="State"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="model.postalCode"
                label="Postal Code"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <country-autocomplete
                v-model="model.country"
                label="Country"
              ></country-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            outlined
            @click="close()"
            :disabled="loading"
            >Cancel</v-btn
          >
          <v-spacer />
          <v-btn
            v-if="model.id"
            color="accent"
            @click="update()"
            :disabled="loading"
            >Update</v-btn
          >
          <v-btn
            v-else
            color="accent"
            @click="add()"
            :disabled="loading"
            >Add</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import CountryAutocomplete from "@components/forms/autocomplete/Country.vue";
import { mapGetters } from "vuex";

export default {
  components: { CountryAutocomplete },
  props: ["item", "open", "clientId"],
  data: () => ({
    model: {
      typeId: null,
      company: null,
      addressLine1: null,
      addressLine2: null,
      city: null,
      state: null,
      country: null,
      postalCode: null,
    },
    valid: null,
    mandatoryRules: [(v) => !!v || "This fields is mandatory"],
    types: [
      { value: "shipping", text: "Shipping Address" },
      { value: "billing", text: "Billing Address" },
    ],
    message: null,
    displayForm: false
  }),
  computed: {
    ...mapGetters('clientAddresses', ['loading'])
  },
  watch: {
    item: function(newVal) {
      // watch it
      Object.assign(this.model, newVal);
    },
  },
  methods: {
    add() {
      if (this.$refs.form.validate()) {
        this.model.clientId = this.clientId;
        this.$store
          .dispatch("clientAddresses/add", {
            model: this.model,
          })
          .then((result) => {
            if (result) {
              this.$emit("updated");
              this.close()
            } else {
              this.message = result.message;
            }
          });
      }
    },
    update() {
      if (this.$refs.form.validate()) {
        this.model.clientId = this.clientId;
        this.$store
          .dispatch("clientAddresses/update", {
            model: this.model,
          })
          .then((result) => {
            if (result) {
              this.$emit("updated");
              this.close()
            } else {
              this.message = result.message;
            }
          });
      }
    },
    close() {
      this.resetForm();
      this.displayForm = false
    },
    resetForm() {
      this.model = {}
      this.$refs.form.reset();
    },
    doOpen(address) {
      Object.assign(this.model, address);
      this.displayForm = true
    }
  },
};
</script>

<style></style>
